module.exports = __webpack_public_path__ + "img/预算公示.f2782198.png";